<template>
    <div class="pcproducts pccourses">
        <el-backtop target=".pcproducts"></el-backtop>
        <div class="vivideot" v-if="vitohomevid">
            <div class="vividecont">
                <video :src="vivideotcon" autoplay="autoplay" controls></video>
                <div class="el-icon-circle-close" @click="viclosevideo"></div>
            </div>
        </div>
        <div class="pchome-headerss">
            <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
        </div>
        <position-bar :productc_nav="producthea_nav" :positionNav="positionNav">
            <div class="videohea-right">
                <div class="videohea-righttitle">
                    <div class="producthearight-item"  v-for="(item,index) in videoclassallss" :style="videotopnavind==item.id?'color:'+nav_color : ''" :key="index" @click="moveNav(item.id)" :id="'leftNav_'+item.id">
                        {{item.name}}
                    </div>
                </div>
            </div>
        </position-bar>

        <div style="padding:10px 0;opacity:0" v-if="producthea_nav">
            <div class="videohea-left">
                {{vidcenter}}
            </div>
        </div>
        <div class="linesd"></div>

        <div class="productfoo" v-for="(item,index) in cacdemy"  :key='index'  :id="'vidscas'+index" :ref="index">
<!--            <div class="pccourses-productfoo-downs" :class="index == 'webinar' ? 'mb0' : ''"  @click="vinavra()" >-->
<!--                {{item.title}}-->
<!--            </div>-->

            <div class="productfoo-shop" >
                <div class="productfoo-item" v-for="(ite,inde) in item.list" :key="inde">
                    <div class="webinar" >
                        <div class="webinar-list">
                            <div class="webinar-item" @click="toWebinarDetail(ite)">
                                <div class="webinar-image">
                                    <div class="mode">
<!--                                        <span>{{ ite.title }}</span>-->
                                        <div class="btn">
                                            <span>More <i class="el-icon-arrow-right"></i></span>
                                        </div>
                                    </div>
                                    <img :src="ite.poster" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="productfoo-more" v-if="item.mess1">
                <div class="more-but" @click="netless(index)" >
                    Up
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" style="transform:scale(1,-1)"/>
                </div>
            </div>
            <div class="productfoo-more" v-else>
                <div class="more-but" @click="netmore(index)" >
                    More
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" />
                </div>
            </div>

        </div>

        <!--        <div class="productfoo" v-for="(item,index) in videoclassliststtcontsecz"  :key='index'  :id="'vidscas'+index">-->
<!--            <div class="pccourses-productfoo-downs" :class="item.id == 1 ? 'mb0' : ''"  @click="vinavra()">-->
<!--                {{prointrod[index].vidtitle}}-->
<!--            </div>-->
<!--            <div class="productfoo-shop" v-if="item.id == 2">-->
<!--                <div class="productfoo-item" v-for="(ite,inde) in item.list" :key="inde" v-if="inde<item.mess2">-->
<!--                    <div class="shop-video"  @mouseleave="video_out(ite)" @mouseenter="video_in(ite)" @click="video_play_click(ite)">-->
<!--                        &lt;!&ndash;						<video :src="ite.video" :id="'video'+ite.id"   muted :style="playing_video_id==ite.id?'opacity:1':'opacity:0'"></video>&ndash;&gt;-->
<!--                        &lt;!&ndash;						<img :src="ite.image"  v-if="playing_video_id !== ite.id" class="video_title_image" >&ndash;&gt;-->
<!--                        &lt;!&ndash; <div class="shopvideo-but" @click="vidostot(ite.video)" >@mouseleave="video_out(ite)" @mouseenter="video_in(ite)" @click="video_play_click(ite)"-->
<!--                            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/pvviplay.png" />-->
<!--                        </div> &ndash;&gt;-->
<!--                        <video-player class="video-player vjs-custom-skin vjs-has-started" :style="{opacity:ite.playVideo ? 1 : 0}" style="transition: all 1s linear 0s;"-->
<!--                                      :ref="'videoPlayer'+ite.id"-->
<!--                                      :playsinline="true"-->
<!--                                      :options="ite.option"-->
<!--                        >-->
<!--                        </video-player>-->
<!--                        <img :src="ite.image" class="video_title_image" :style="{opacity:ite.playVideo ? 0 : 1}" style="transition: all 1s linear 0s;">-->
<!--                    </div>-->
<!--                    &lt;!&ndash;						<div class="shop-icon" @click="downvideo(ite)" >&ndash;&gt;-->
<!--                    &lt;!&ndash;							<div class="shopicon-left">&ndash;&gt;-->
<!--                    &lt;!&ndash;								{{ite.title}}&ndash;&gt;-->
<!--                    &lt;!&ndash;							</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;							<div class="shopicon-right">&ndash;&gt;-->
<!--                    &lt;!&ndash;								<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/download.svg" />&ndash;&gt;-->
<!--                    &lt;!&ndash;							</div>&ndash;&gt;-->
<!--                    &lt;!&ndash;						</div>&ndash;&gt;-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="productfoo-shop" v-if="item.id == 1">-->
<!--                <div class="productfoo-item" v-for="(ite,inde) in item.list" :key="inde">-->
<!--                    <div class="webinar" >-->
<!--                        <div class="webinar-list">-->
<!--                            <div class="webinar-item" >-->
<!--                                <div class="webinar-image">-->
<!--                                    <img :src="ite.image" alt="">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="productfoo-more" v-if="item.mess1">-->
<!--                <div class="more-but" @click="netmore(item.id)" >-->
<!--                    {{networkco}}-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" />-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="productfoo-more" v-else>-->
<!--                <div class="more-but" @click="netless(item.id)" >-->
<!--                    {{networkco_pack}}-->
<!--                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg" style="transform:scale(1,-1)"/>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <footers ref=is_change ></footers>
    </div>
</template>

<script>
    import 'lib-flexible/flexible.js'
    import {session} from '../../storage/storage.js';
    import headers from '../../common/header.vue'
    import footers from '../../common/footers.vue'
    import positionBar from '../../components/position-bar.vue'

    export default{
        data(){
            return{
                producthea_nav:false,
                id:'',
                vitohomevid:false,
                videonavnums:5,
                vivideotcon:'',
                videoclassliststtcontsecz:[],
                videonavall:'全部',
                vidcenter:'视频中心',
                prointrod:'产品介绍',
                casesha:'案例分析',
                networkco:'显示更多',
                networkco_pack:'收起列表',
                navheader:true,
                heshow:false,
                show: false,
                playli:true,
                playri:true,
                videoclassallss: [
                    {
                        id:1,
                        name:'Courses',
                    },
                    {
                        id:2,
                        name:'Videos',
                    },
                ],
                videoclassliststt:'',
                videotopnavind:0,
                classidd:0,
                options: [{
                    value: '选项1',
                    label: '啄木鸟官网'
                }, {
                    value: '选项2',
                    label: '啄木鸟官网1'
                }, {
                    value: '选项3',
                    label: '啄木鸟官网2'
                }, {
                    value: '选项4',
                    label: '啄木鸟官网3'
                }, {
                    value: '选项5',
                    label: '啄木鸟官网4'
                }],
                optionslang: [{
                    valuelang: '选项1',
                    labellang: 'CN'
                }, {
                    valuelang: '选项2',
                    labellang: 'EN'
                }],
                value: '',
                valuelang: '',
                list_img: [
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:1,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:2,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:3,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:4,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:5,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:6,is_cover:true},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:2,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:3,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcproductimg/productin.png"),id:4,is_cover:false},
                ],
                scroll_height:0,
                playing_video_id:0,
                nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
                is_query:true,

                playerOptions: null,
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'Academy',
                        path:'/pccourses',
                    },
                    {
                        title:'Courses',
                        path:'',
                    },
                ],
                cacdemy:{
                    webinar:{
                        title:'Online',
                        list:[],
                        mess1:false,
                        page:{
                            current_page:1,
                            last_page:1,
                        }
                    },
                    // hands_on:{
                    //     title:'Off-line',
                    //     list:[],
                    //     mess1:false,
                    //     page:{
                    //         current_page:1,
                    //         last_page:1,
                    //     }
                    // }
                }
            }
        },
        components:{
            headers,
            footers,
            positionBar
        },
        created() {
            /* this.value=this.options[0].label
            this.valuelang=this.optionslang[0].labellang */
            // this.getParams()
            // this.videoclassall()
            // this.videoclasslist()
            this.heshow=true

        },
        watch:{
            '$route': 'getParams'
        },
        mounted() {

            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.$router.push({path:'./phcourses',query:{e:this.$route.query.e}})
            }

            sessionStorage.setItem('page',JSON.stringify({name:'pccourses',data:false}))
            this.initData()
        },
        methods: {
            toWebinarDetail(item){
                this.$router.push({path: '/pc-webinar-detail',query:{id:item.id}})
            },
            initData(){
            // ,new Promise((resolve, reject) => {
            //         this.$api.get_cacdemy_courses_hands_on_list().then(res => {
            //             resolve(res)
            //         })
            //     })
                const _this = this
                Promise.all([new Promise((resolve, reject) => {
                    this.$api.get_cacdemy_courses_webinar_list().then(res => {
                        resolve(res)
                    })
                })]).then(res => {
                    this.cacdemy.webinar.list = res[0].data.data
                    this.cacdemy.webinar.page.current_page = res[0].data.current_page
                    this.cacdemy.webinar.page.last_page = res[0].data.last_page
                    this.cacdemy.hands_on.list = res[1].data.data
                    this.cacdemy.hands_on.page.current_page = res[1].data.current_page
                    this.cacdemy.hands_on.page.last_page = res[1].data.last_page
                    // this.cacdemy.hands_on.list.map((v,i) => {
                    //     v.option = _this.makePlayerOptions(v)
                    //     v.mess1 = true
                    //     v.mess2 = 8
                    //     this.$set(v,'playVideo',false)
                    //     this.$set(v,'first',true)
                    // })
                })
            },
            webinarList(){
                this.cacdemy.webinar.page.current_page ++
                this.$api.get_cacdemy_courses_webinar_list({
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.cacdemy.webinar.page.current_page
                }).then(res => {
                    this.cacdemy.webinar.list = this.cacdemy.webinar.list.concat(res.data.data)
                    if(this.cacdemy.webinar.page.current_page >= this.cacdemy.webinar.page.last_page){
                        this.cacdemy.webinar.mess1 = true
                    }
                })
            },
            handsOnList(){
                const _this = this
                this.cacdemy.hands_on.page.current_page ++
                this.$api.get_cacdemy_courses_hands_on_list({
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.cacdemy.hands_on.page.current_page
                }).then(res => {
                    // res.data.data.map((v,i) => {
                    //     v.option = _this.makePlayerOptions(v)
                    //     v.mess1 = true
                    //     v.mess2 = 8
                    //     this.$set(v,'playVideo',false)
                    //     this.$set(v,'first',true)
                    // })
                    this.cacdemy.hands_on.list = this.cacdemy.hands_on.list.concat(res.data.data)
                    if(this.cacdemy.hands_on.page.current_page >= this.cacdemy.hands_on.page.last_page){
                        this.cacdemy.hands_on.mess1 = true
                    }

                })
            },
            // onPlayerPlay(e,id){
            // 	console.log('id')
            // 	console.log(id)
            // 	var video = this.$refs['videoPlayer'+id]
            // 	video.player.play()
            // },
            vinavra(e){
                id = document.getElementById(`id${i.product_id}`);

            },
            netmore(index){
                if(this.cacdemy[index].page.last_page == 1){
                    this.cacdemy[index].mess1 = this.cacdemy[index].mess1 ? false : true
                    return
                }
                index == 'webinar' ? this.webinarList() : this.handsOnList()
            },
            netless(index){
                if(this.cacdemy[index].page.last_page == 1){
                    this.cacdemy[index].mess1 = this.cacdemy[index].mess1 ? false : true
                    return
                }
                this.cacdemy[index].page.current_page = 0
                this.cacdemy[index].mess1 = false
                this.cacdemy[index].list = []
                index == 'webinar' ? this.webinarList() : this.handsOnList()

            },
            downvideo(e){
                this.$utils.handleDownloadUri(e.title,e.video)
            },
            ChangeEmit(){ //子组件传递
                //主动调用子组件
                this.$refs.is_change.get_index_channel_data();
                this.$refs.is_change.pageParam();
                this.getParams()
                this.videoclassall()
                this.videoclasslist()
                this.pageParam() //页面静态参数
            },
            videodwon(){
                if(this.videonavnums==5){
                    this.videonavnums=50
                    this.videoclassall()
                }else{
                    this.videonavnums=5
                    this.videoclassall()
                }


            },
            viclosevideo(){
                this.vitohomevid=false
            },
            vidostot(e){
                // var player = this.$video('video'+index,{});
                // console.log(index)
                // this.play()
                // let player = this.$video(this.$refs.video1)
                // document.getElementsByClassName('video')[1].play()
                this.vitohomevid=true
                this.vivideotcon=e
            },
            moveNav(e){
                // this.videotopnavind=e
                // this.classidd=e
                //
                // if(e == 1){
                //     this.$refs.webinar[0].scrollIntoView()
                // }else {
                //     this.$refs.hands_on[0].scrollIntoView()
                // }
                e == 1 ? this.$router.push({path: '/pccourses'}) : this.$router.push({path: '/pc-academy-videos'})

            },
            videoclinav(e){
                this.videotopnavind=e
                this.classidd=e
                this.videoclasslist()
            },
            videoclassall(){
                // let data={
                // 		lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                // 		channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                // 		page:1,
                // 		pageSize:this.videonavnums,
                // 	}
                // this.$api.get_video_class_all(data).then((res) => {
                // 		  this.videoclassallss=res.data
                // 			this.videoclinav(this.videoclassallss[0].id)
                // });
                // this.videoclassallss = [
                // 	{
                // 		id:1,
                // 		name:'线上课',
                // 	},
                // 	{
                // 		id:2,
                // 		name:'实操课',
                // 	},
                // ]
                this.videoclinav(this.videoclassallss[0].id)

            },
            videoclasslist(){
                const _this = this
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold:'pc',
                    page:1,
                    pageSize:500000,
                    class_id:this.classidd,
                }
                this.$api.get_video_class_list(data).then((res) => {

                    this.videoclassliststt=res.data
                    this.videoclassliststtcontsecz=[]
                    this.videoclassliststt.map((item, index)=> {
                        // this.videoclassliststtcontsecz.push(Object.assign({},item,{mess1:true,mess2:8}))
                        this.videoclassliststtcontsecz.push(Object.assign({},item,{
                            mess1:true,
                            mess2:8
                        }))
                        item.list.map((v,i) => {
                            v.option = _this.makePlayerOptions(v)
                            this.$set(v,'playVideo',false)
                            this.$set(v,'first',true)
                        })
                    })
                    // console.log('videoclassliststtcontsecz',this.videoclassliststtcontsecz)
                    if(this.is_query){
                        // document.getElementById("vidscas"+this.$route.query.e).scrollIntoView
                        // var vidscas = document.getElementById('vidscas'+this.$route.query.e)
                        // console.log('vidscas++:'+vidscas)
                        // if(vidscas != null){
                        //   vidscas.scrollIntoView()
                        //   // document.documentElement.scrollTop = document.querySelector('#vidscas'+this.$route.query.e).offset().top
                        // }
                        this.$refs.is_change.scrollIntoView('vidscas'+this.$route.query.e)

                        this.is_query = false
                    }
                });
            },
            handleScroll () {
                let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()
                if(scrollTop>head_height){
                    // if(scrollTop>this.scroll_height){
                    this.producthea_nav = true
                    // }else{
                    // 	this.producthea_nav = false
                    // }
                    this.scroll_height = scrollTop
                }else{
                    this.producthea_nav = false
                }
                this.$refs.head.scrollTop_change(scrollTop,'pcelites')
            },
            pageParam(){
                let lang =  session.get("lang");
                if (lang === "cn"){
                    this.vidcenter = "视频中心"
                    this.videonavall="全部"
                    this.prointrod="产品介绍"
                    this.casesha="案例分析"
                    this.networkco="显示更多"
                    this.prointrod =  [
                        {'vidtitle':'线上课'},
                        {'vidtitle':'实操课'},
                    ]
                }else{
                    this.vidcenter = "VIDEO"
                    this.videonavall="all"
                    this.prointrod="Product Introduction"
                    this.casesha="Case sharing"
                    this.networkco="Show more"
                    this.prointrod =  [
                        {'vidtitle':'线上课'},
                        {'vidtitle':'实操课'},
                        {'vidtitle':'Webinar'},
                    ]
                }
            },
            hometo(){
                this.$router.push({path: '/pchome'})
            },
            videoto(){
                this.$router.push({path: '/pcvideos'})
            },
            queryto(){
                this.$router.push({path: '/pcquerys'})
            },
            productto(){
                this.$router.push({path: '/pcproduct'})
            },
            elitesto(){
                this.$router.push({path: '/pcelites'})
            },
            contactusto(){
                this.$router.push({path: '/pccontactus'})
            },
            aboutto(){
                this.$router.push({path: '/pcabout'})
            },
            seachto(){
                this.$router.push({path: '/pcseachs'})
            },
            nextimg(){
                let l = this.list_img.length;
                let scroll = document.getElementById('scroll-x');
                let diatance = scroll.scrollWidth - scroll.clientWidth;
                if(this.current_index == 0){
                    this.current_index = l-1;
                    scroll.scrollLeft = diatance;
                }else{
                    this.current_index--;
                    scroll.scrollLeft -= diatance / (l - 1);
                }
            },
            preimg(){
                let l = this.list_img.length;
                let scroll = document.getElementById('scroll-x');
                let diatance = scroll.scrollWidth - scroll.clientWidth;
                if(this.current_index+1 == l){
                    this.current_index = 0;
                    scroll.scrollLeft = 0;
                }else{
                    this.current_index++;
                    scroll.scrollLeft += diatance / (l - 1);
                }
            },
            enter(index){
                this.navheader= true;
            },
            playenterli(){
                this.playli=false
            },

            playenterri(){
                this.playri=false
            },
            playleaveli(){
                this.playli=true
            },
            playleaveri(){
                this.playri=true
            },
            getParams () {
                this.id = this.$route.query.e
                this.$refs.is_change.scrollIntoView('vidscas'+this.$route.query.e)
            },
            video_in(item){
                // this.playing_video_id = item.id
                // setTimeout(() => {
                // 	var video = document.getElementById('video'+item.id)
                // 	video.play()
                // }, 10);
                // this.playerOptions = this.makePlayerOptions(item)
                let ref = 'videoPlayer'+item.id
                if(item.first){
                    item.first = false
                    this.$refs[ref][0].player.src(item.video)
                }
                item.playVideo = true
                this.$refs[ref][0].player.play()

            },
            video_out(item){
                item.playVideo = false
                let ref = 'videoPlayer'+item.id
                this.$refs[ref][0].player.src(item.video)
                // this.$refs[ref][0].player.src(item.video)
                // var _this = this , video = document.getElementById('video'+item.id)
                // video.pause()
                // video.currentTime = 0
                // _this.playing_video_id = 0
                // setTimeout(() => {
                // 	_this.playing_video_id = 0
                // }, 10);
            },
            makePlayerOptions(o){
                return  {
                    //播放速度
                    // playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: true,
                    // 导致视频一结束就重新开始。
                    loop: true,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    // preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: o.video
                        // src: 'https://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/5fc120f6387702294747604227/f0.mp4'
                    }],
                    //你的封面地址
                    poster: o.poster,
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    // notSupportedMessage: '此视频暂无法播放，请稍后再试',
                }
            },
            video_play_click(item){
                window.open(item.video)
            }
        }
    }
</script>

<style >

    body{
        margin: 0;
        padding: 0;
        background: #fff;
    }
    .pccourses .pcproducts{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
    }
    .pccourses .pchome-headerss{
        width: 100%;
        position: relative;
        background-size: 100% 100%;
        padding-top:119px;
        box-sizing: border-box;
        background-color: #ffffff;
    }

    .pccourses .checse{
        margin-top: 0 !important;
    }
    .pccourses .product-title{
        color: #fff;
        margin-top: 249px;
        margin-left: 240px;
    }
    .pccourses .title-hea{
        font-size: 20px;
        font-weight: normal;
        letter-spacing: 1px;
    }
    .pccourses .title-model{
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 44px;
        font-weight: normal;
        letter-spacing: 2px;
    }
    .pccourses .product-but{
        margin-top: 40px;
        font-size: 16px;
        width: 110px;
        height: 46px;
        background: #E31E24;
        border-radius: 23px;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
    }
    /* .header-navss{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .nav-wit{

    }
    .pccourses .nav-left{
        width: 100px;
        height: 50px;
    }
    .pccourses .nav-left img{
        width: 100%;
        height: 100%;
    }
    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .pccourses .nav-center-item:first-child{
        margin-left: 0;
    }
    .pccourses .nav-right{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }
    .pccourses .nav-right .search{
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }
    .pccourses .nav-right .search img{
        width: 100%;
        height: 100%;
    }
    .pccourses .nav-right .homename{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }
    .pccourses .nav-right .homename img{
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }
    .pccourses .nav-right .language{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pccourses .nav-right .language img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }

    .pccourses .bb{
        background: #FAFAFA;
        position: fixed;
        top: 0;
        z-index: 99;
    }
    .pccourses .aboutitem-hea{
        margin-top: 80px;
        margin-bottom: 40px;
        height: 33px;
        font-size: 24px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 33px;
        letter-spacing: 1px;
    }
    .pccourses .aboutitem-fooitem{
        margin-bottom: 10px;
    }
    .pccourses .fooitem-left{
        width: 110px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #EAEAEA;
        display: flex;
        align-items: center;
        justify-content: center;


        font-size: 16px;
        font-weight: 400;
        color: #FAFAFA;
        margin-right: 20px;
    }
    .pccourses .fooitem-left img{
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }
    .pccourses .aboutitem-foosus{
        display: flex;
        margin-bottom: 20px;
    }
    .pccourses .fooitem-right{
        font-size: 16px;
        font-weight: 400;
        color: #CCCCCC;
    }
    .pccourses .fooitem-cont{
        margin-top: 25px;
        margin-left: 40px;
    }
    .pccourses .fooitem-cont:first-child{
        margin-left: 0px;
    }
    .pccourses .fooite-img{
        display: flex;
    }
    .pccourses .fooite-img img{
        width: 90px;
        height: 90px;
    }
    .pccourses .fooite-nam{
        text-align: center;
        margin-top: 20px;
    }
    .pccourses .right-tit{
        margin-bottom: 5px;
    }
    .pccourses .homefoot{

        height: 94px;
        background: #272727;
        border-top: 2px solid #666;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .pccourses .foot-hea{
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
    }
    .pccourses .foot-f{
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .pccourses .videohea{
        width: 1400px;
        /* height: 80px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 260px;
    }
    .pccourses .videohea-left{
        font-size: 28px;
        color: #5d5f5f;
    }
    .pccourses .videohea-right{
        display: flex;

    }
    .pccourses .videohea-righttitle{
        max-width: 800px;
        display: flex;
        font-size: 16px;
        flex-wrap: wrap;
        margin-left: -24px;
        color: #5d5f5f;
        margin-top: 10px;
    }
    .pccourses .producthearight-item{
        margin-bottom: 10px;
        cursor: pointer;
        margin-left: 24px;
    }
    .pccourses .producthearight-item:first-child{
        margin-left: 0px;
    }
    .pccourses .videohea-righticon{
        width: 20px;
        height: 20px;
        margin-left: 9px;
        display: flex;
        align-items: center;
        margin-top: 10px;
    }
    .pccourses .videohea-righticon img{
        width: 100%;
        height: 100%;
    }
    .pccourses .linesd{
        width: 1400px;
        height: 1px;
        background: #EAEAEA;
        margin: 0 auto;
    }
    .pccourses .productfoo{
        width: 1400px;
        display: flex;
        flex-direction: column;
        padding: 0 260px;

    }
    .pccourses .pccourses-productfoo-downs{
        font-size: 28px;
        font-weight: 500;
        color: #5d5f5f;
        margin-top: 60px;
        margin-bottom: 60px;
    }

    .pccourses .productfoo-shop{
        display: flex;
        flex-wrap: wrap;
        margin-left: -40px;
    }
    .pccourses .productfoo-item{
        width: 320px;
        margin-left: 40px;
    }
    .pccourses .shop-video{
        position: relative;
        width: 320px;
        height: 180px;
        display: flex;
        cursor: pointer;
    }
    .pccourses .shop-video video{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
    .pccourses .shopvideo-but{
        position: absolute;
        top: 70px;
        left: 140px;
        width: 40px;
        height: 40px;
        display: flex;
    }
    .pccourses .shopvideo-but img{
        width: 100%;
        height: 100%;
    }
    .pccourses .video_title_image{
        border-radius: 10px;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    .pccourses .shop-icon{
        width: 320px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
    }
    .pccourses .shopicon-left{
        width: 300px;
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
    }
    .pccourses .shopicon-right{
        width: 20px;
        height: 20px;
        margin-right: 12px;
        cursor: pointer;
        display: flex;
    }
    .pccourses .shopicon-right img{
        width: 100%;
        height: 100%;
    }
    .pccourses .productfoo-more{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 80px;
    }
    .pccourses .more-but{
        width: 120px;
        height: 40px;
        border-radius: 40px;
        border: 1px solid #CCCCCC;
        font-size: 14px;
        color: #999999;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-top: 40px;
    }
    .pccourses .more-but img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }
    .vjs-big-play-button{
        left:50% !important;
        top: 50% !important;
        margin-top: -1em ;
        margin-left: -1.5em ;
    }
    .viotopna{
        color: #D03E3D;
    }

    .pccourses .vivideot{
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,.32);
        position: fixed;
        top: 0px;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pccourses .vividecont{
        position: relative;
        width: 1200px;
        height: 600px;
    }
    .pccourses .vividecont video{
        width: 1200px;
        height: 600px;
    }
    .pccourses .el-icon-circle-close{
        font-size: 40px;
        color: #fff;
        position: absolute;
        top: -20px;
        right: -16px;
        cursor: pointer;
    }
    /* .header-nav{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .nav-wit{

    }
    .pccourses .nav-left{
        width: 100px;
        height: 50px;
    }
    .pccourses .nav-left img{
        width: 100%;
        height: 100%;
    }
    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .pccourses .nav-center-item:first-child{
        margin-left: 0;
    }
    .pccourses .nav-right{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }
    .pccourses .nav-right .search{
        display: flex;
        align-items: center;
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }
    .pccourses .nav-right .search img{
        width: 100%;
        height: 100%;
    }
    .pccourses .nav-right .homename{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }
    .pccourses .nav-right .homename img{
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }
    .pccourses .nav-right .language{
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .pccourses .nav-right .language img{
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }
    .pccourses .producthea_nav{
        top: 0;
        position: fixed;
        z-index: 9;
        background-color: #fff;
        background: rgba(255,255,255,.72);
        backdrop-filter: saturate(180%) blur(20px);
    }

    .pccourses .shop-video .video-player {
        width: 100%;
    }
    .pccourses .shop-video .video-js {
        background-color: #ffffff;
    }
    .pccourses .shop-video .video-player .vjs-control-bar,
    .pccourses .shop-video .video-player .vjs-big-play-button{
        display: none;
    }

    /* 线上课 start */
    .pccourses .webinar {
        //width: 1400px;
        //margin: 0 auto;
    }
    .pccourses .webinar .webinar-list {
        display: flex;
        flex-wrap: wrap;
    }
    .pccourses .webinar .webinar-list .webinar-item {
        font-size: 24px;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,.1);
        border-radius: 10px;
        overflow: hidden;
        margin-left: 65px;
        margin-top: 65px;
        position: relative;
        cursor: pointer;
    }
    .pccourses .webinar .webinar-list .webinar-item:hover .webinar-image img{
        transform: scale(1.05);
    }
    .pccourses .webinar .webinar-list .webinar-item .webinar-image .mode {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.5);
        left: 0;
        top: 0;
        z-index: 10;
        opacity: 0;
        transition: opacity .3s linear 0s;
    }
    .pccourses .webinar .webinar-list .webinar-item .webinar-image .mode .btn {
        --background-spread: 200px;
        --border-width: 2px;
        --border-radius: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background-color: #ffffff;
        color: #606266;
        border-radius: var(--border-radius);
        overflow: hidden;
        font-size: 16px;
        border: 0;
        padding: 1px;
    }

    .pccourses .webinar .webinar-list .webinar-item .webinar-image .mode .btn::after {
        content: '';
        position: absolute;
        /*background: conic-gradient(from 180deg at 50% 50%, #00D1FF 0deg, #EE27FF 106.88deg, #205EFF 206.25deg, #00F0FF 286.87deg, #00D1FF 360deg);*/
        top: calc(var(--background-spread) * -1);
        right: calc(var(--background-spread) * -1);
        bottom: calc(var(--background-spread) * -1);
        left: calc(var(--background-spread) * -1);
        z-index: -1;
        animation: 3s rotate linear infinite;
    }

    .pccourses .webinar .webinar-list .webinar-item .webinar-image .mode .btn > span {
        display: block;
        background-color: #ffffff;
        padding: 8px 20px;
        border-radius: calc(var(--border-radius) - var(--border-width) / 2);
    }

    .pccourses .webinar .webinar-list .webinar-item .webinar-image .mode .btn span i {
        font-size: 12px;
    }
    .pccourses .webinar .webinar-list .webinar-item:hover .webinar-image .mode {
        opacity: 1;
    }
    .pccourses .webinar .webinar-list .webinar-item:nth-child(4n+1){
        margin-left: 0;
    }
    .pccourses .webinar .webinar-list .webinar-item .webinar-image{
        overflow: hidden;
    }
    .pccourses .webinar .webinar-list .webinar-item .webinar-image img{
        transition: all .75s ease 0s;
        width: 300px;
        height: 376px;
        display: block;
    }
    .pccourses .webinar .webinar-list .webinar-item .webinar-text {
        padding: 20px 10px;
    }
    /* 线上课 end */
</style>
